<template>
    <div class="card_animation_wrap">
        <div  class="card_animation">
            <img v-if="img" :src="img" class="animation_bg" />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        img: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            timeout: "",
        }
    },
    methods: {
        show() {
            clearTimeout(this.timeout);
            $(".card_animation").fadeIn(1000);
            this.timeout = setTimeout(() => {
                $(".card_animation").fadeOut(1000, function() {
                    this.img = "";
                    clearTimeout(this.timeout);
                });
            }, 3000);
        },
    },
}
</script>
<style lang="scss">
.card_animation_wrap{
    .card_animation {
        position: fixed;
        top: 50%;
        left: 50%;
        width: 800px;
        height: 800px;
        transform: translate(-50%, -50%);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
        z-index: 5;
        animation: cordAnimation 0.1s infinite;
        display: none;
        border-radius: 20px;
    }
    .animation_bg {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 400px;
        height: 400px;
        transform: translate(-50%, -50%);
        border: none;
    }
    @keyframes cordAnimation {
        0% {
             background-image: url("~@/assets/tic/bg1.png"); 
        }
        100% {
             background-image: url("~@/assets/tic/bg2.png"); 
        }
    }
}


</style>


// WEBPACK FOOTER //
// src/views/classroom1/components/cardAnimation.vue